import AttachServiceToAssetForm from './AttachServiceToAssetForm';

export default AttachServiceToAssetForm;
